import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconReject(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.786 6.382a1 1 0 0 0-1.572 0l-5.5 7A1 1 0 0 0 6.5 15h11a1 1 0 0 0 .786-1.618l-5.5-7ZM15.443 13H8.556L12 8.619 15.443 13ZM6 17a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
